export default function (key) {
  if (typeof TYPO3 === 'object' && typeof TYPO3.lang === 'object' && typeof TYPO3.lang[key] === 'string') {
    return TYPO3.lang[key];
  }
  return key;
}
